// ----------------------------------------------------------------------

// Single source of truth for tool access. Returns true if any of:
//   - user is staff (admin override)
//   - user holds an active perk for the requested perk_name
//   - user has at least one unconsumed one-shot credit for that perk
//     (granted via campaign gift, courtesy, or future product variants)
// Adding a new credit-granting product anywhere ⇒ no frontend change.
export function canAccessModule(user, perk) {
    if (!user) {
        return false;
    }
    if (user.is_staff) {
        return true;
    }
    const userPerk = user.perks_on_user?.find(p => p.perk_name === perk);
    if (userPerk?.can_access) {
        return true;
    }
    if ((user.available_credits?.[perk] ?? 0) > 0) {
        return true;
    }
    return false;
}
